import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const BourgExchange = () => {
  return (
    <div className="min-h-screen bg-stone-950 text-stone-200 font-serif">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-stone-400 hover:text-stone-200 transition-colors mb-8"
        >
          <ArrowLeft size={16} /> Back to Institute
        </Link>

        <header className="border-b-2 border-amber-500 pb-8 mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-amber-500 mb-2">
            THE BOURG EXCHANGE TR
          </h1>
          <p className="text-stone-400 text-lg">A Merchant Exchange Business Trust</p>
        </header>

        <section className="mb-10">
          <h2 className="text-xl text-amber-500 border-b border-stone-700 pb-2 mb-4">
            Structure
          </h2>
          <p className="text-stone-300 leading-relaxed">
            The Bourg Exchange TR is a merchant exchange business trust designed to serve the needs of participants operating in commerce. It operates as an Indenture Trust functioning as a cutting house and retail securitization facility for and on behalf of the Repository Banking Trust.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl text-amber-500 border-b border-stone-700 pb-2 mb-4">
            Roles
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { title: "Cutting House", desc: "Clearing and settlement of commercial transactions between participants" },
              { title: "Retail Securitization Facility", desc: "Packaging and issuance of retail assets into securitized instruments" },
              { title: "Treasury Management", desc: "Management of treasury operations for the Repository Banking Trust" },
              { title: "Global Exchange", desc: "Facilitation of international commercial exchange" },
              { title: "Asset Warehouse", desc: "Custody and warehousing of assets on behalf of the Repository Banking Trust" },
            ].map((role) => (
              <div key={role.title} className="bg-stone-900/60 border border-stone-800 rounded-lg p-5">
                <h3 className="text-amber-500 font-semibold mb-2">{role.title}</h3>
                <p className="text-stone-400 text-sm">{role.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-10">
          <h2 className="text-xl text-amber-500 border-b border-stone-700 pb-2 mb-4">
            Asset Types
          </h2>
          <ul className="text-stone-300 space-y-2 list-disc list-inside">
            <li>Fruit Forests — agricultural and land-based assets</li>
            <li>Growlab — cultivation and development operations</li>
            <li>Vivarium — living systems and biological assets</li>
            <li>Health — wellness and athletic training facilities</li>
            <li>Community — neighborhood exchange networks</li>
            <li>Edification — mentorship and educational programs</li>
          </ul>
        </section>

        <section className="mb-10">
          <h2 className="text-xl text-amber-500 border-b border-stone-700 pb-2 mb-4">
            Function
          </h2>
          <p className="text-stone-300 leading-relaxed">
            The Bourg Exchange TR issues assets as the Treasury Management, Global Exchange, and asset warehouse of the Repository Banking Trust. It provides warehouse line lending and program statement services to retail banks, operating as a private, non-marketable exchange dealing exclusively with its own capital.
          </p>
        </section>

        <footer className="text-center text-stone-500 text-sm border-t border-stone-800 pt-8 mt-12">
          <p>THE BOURGANIZATION INSTITUTE — a 501(c)(6) business league</p>
          <p>bgnzn.org</p>
        </footer>
      </div>
    </div>
  );
};

export default BourgExchange;
